import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import { Switch, Tooltip } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';
import * as Sentry from '@sentry/react';
import { Image, Skeleton, Typography } from 'antd';
import Loading from 'components/Loading';
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import React, { forwardRef, useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useCurrentClass } from 'store/classes/selectors';
import { handleShareSoyStoryToStudent } from 'store/StoryAiCofig/thunks';
import { useCurrentUser } from 'store/users/selectors';
import styled from 'styled-components';
import { useNotificationHistorias } from 'utils/methods/firebaseSoyHistorias';
import { useLocation } from 'react-router-dom';
import { v4 } from 'uuid';
import StoryAudioReader from './StoryReader';
import SentryWrap from 'components/Sentry';
import ModalMenu from 'components/Modals';
const { Title, Paragraph } = Typography;

const VisibilityToggle = muiStyled(Switch)({
  width: 38,
  height: 20,
  padding: 0,
  display: 'flex',
  '& .MuiSwitch-switchBase': {
    padding: 1,
    '&.Mui-checked': {
      transform: 'translateX(18px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: '#22c55e'
      }
    }
  },
  '& .MuiSwitch-thumb': {
    width: 18,
    height: 18,
    boxShadow: '0 2px 6px rgba(0, 0, 0, 0.25)'
  },
  '& .MuiSwitch-track': {
    borderRadius: 10,
    opacity: 1,
    backgroundColor: '#ef4444'
  }
});

const Container = styled.div`
  background-color: #341b55;
  color: white;
  padding: 10px 10px 10px 10px;
  text-align: center;
  position: relative;
  overflow: auto;
  height: 100%;

  @media print {
    background-color: white !important;
    color: black !important;
    padding: 35px !important; 
    margin: 0;
    border: none;
    width: 100%;
    height: auto;
    overflow: visible;
    border-radius: 0px;
    page-break-before: auto;
    page-break-after: auto;

    .lesson-plan-container {
      page-break-inside: avoid;
    }
  }
`;

const StyledTitle = styled(Title)`
  color: white !important;
  font-weight: bold;
  text-align: center;
  margin-bottom: 2px !important;
  max-width: 60%;
  margin: 0 auto;
  font-size: 19px !important;
  @media (max-width: 1024px){
    max-width: 80%;
  }

  @media screen and (max-width: 600px) {
    font-size: 15px !important;
    max-width: 60%;
  }
  @media print {
    color: black !important;
    font-size: 22px;
    margin-bottom: 10px !important;
  }
`;
const ContentWrapper = styled.div`
  // max-width: 800px;
  margin: 0 auto;
  padding: 12px;
  overflow-y: auto;
  width: 100%;
  font-size: 18px;
  border-top: 0.5px dashed lightgray;
  padding-bottom: 135px;
  max-height: ${({ isLevel, isStudent, storyContainerHeight, location, isStory }) =>
    isLevel
      ? isStudent
        ? isStory ? "100%" : storyContainerHeight - 190
        : storyContainerHeight - 245
      : isStudent
        ? location.pathname=='/balconCulturalBook' ?storyContainerHeight - 90:storyContainerHeight - 200
        : storyContainerHeight - 200}px;

  @media screen and (min-width: 801px) and (max-width: 831px) {
    max-height: ${({ $isLevel, $isStudent, $storyContainerHeight, $location }) =>
    $isLevel
      ? $isStudent
        ? $storyContainerHeight - 140
        : $storyContainerHeight - 140
      : $isStudent
        ? $location.pathname=='/balconCulturalBook' ?$storyContainerHeight - 90:$storyContainerHeight - 50
        : $storyContainerHeight - 217}px !important;
  }

  @media screen and (min-width: 831px) and (max-width: 991px) {
    max-height: ${({ $isLevel, $isStudent, $storyContainerHeight, $location }) =>
    $isLevel
      ? $isStudent
        ? ""
        : $storyContainerHeight - 200
      : $isStudent
        ? $storyContainerHeight - 70
        : $storyContainerHeight - 210}px !important;
  }

  @media screen and (min-width: 991px) {
    max-height: ${({ $isLevel, $isStudent, $storyContainerHeight, $location, $isStory }) =>
    {const value = $storyContainerHeight ?
    $isLevel
      ? $isStudent
        ? 100
        : $storyContainerHeight - 200
      : $isStudent
        ? $location.pathname=='/balconCulturalBook' ? $isStory ? 100 : $storyContainerHeight - 100 : $isStory ? 79: $storyContainerHeight - 270
        : $storyContainerHeight - 220
      : 428;
    return `${value}${$isStory ? '%' : 'px'}`;
    }}!important;  
  }

  @media screen and (min-width: 601px) and (max-width: 800px) {
    max-height: ${({ $isLevel, $isStudent, $storyContainerHeight, $location, $isStory }) =>
    {
    const value = $storyContainerHeight
      ? $isLevel
        ? $isStudent
          ? $storyContainerHeight - 190
          : $storyContainerHeight - 225
        : $isStudent
        ? $location.pathname == '/balconCulturalBook' ? $storyContainerHeight - 100 : $storyContainerHeight - 70
        : $storyContainerHeight - 220
      : 303;
    return `${value}${$isStory ? '%' : 'px'}`;
    }}!important; 
  }
  @media screen and (max-width: 991px) {
   max-height: ${({ $isLevel, $isStudent, $storyContainerHeight, $location }) =>
    !$storyContainerHeight && 364 }px !important;
   }
  @media screen and (max-width: 760px) {
   max-height: ${({ $isLevel, $isStudent, $storyContainerHeight, $location }) =>
    !$storyContainerHeight && 219 }px !important;
   }

   @media screen and (max-width: 475px) {
    max-height: ${({ $isLevel, $isStudent, $storyContainerHeight, $location, $isStory }) =>
      $isStudent ? $isStory ? "100% !important" : "380px !important" : "300px !important"
    }
   }

   @media screen and (max-width: 400px) {
    max-height: ${({ $isLevel, $isStudent, $storyContainerHeight, $location, $isStory }) =>
      $isStudent ? $isStory ? "100% !important" : "350px !important" : "215px !important"
    }
   }

   @media screen and (max-width: 380px) {
    max-height: ${({ $isLevel, $isStudent, $storyContainerHeight, $location, $isStory }) =>
      $isStudent ? $isStory ? "100% !important" : "320px !important" : "215px !important"
    }
   }

  @media print {
    border-top: 0 !important;
    max-height: unset;
    overflow: visible;
    height: auto;
    padding: 0;
    margin: 0;
    font-size: 16px;
    orphans: 2;
    widows: 2;

    & > div {
      page-break-inside: auto !important;
      break-inside: auto !important;
    }
  }
`;

const ToggleWrapper = styled.span`
  // position: absolute;
  top: 0;
  right: 5px;
  margin-top: 10px;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: #fff;
  border-radius: 999px;
  padding: 4px 10px 4px 12px;
  @media print {
    display: none;
  }
`;

const ToggleText = styled.span`
  font-size: 12px;
  font-weight: 600;
  min-width: 92px;
  @media (max-width: 1024px){
    display: none;
  }
`;

const StyledHtml = styled.span`
  &,
  & * {
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
  }
  cursor: default;
`;
const StyledParagraph = styled(Paragraph)`
  color: white;
  text-align: left;
  line-height: 1.8;
  font-size: 18px;
  @media Screen and (max-width: 600px){
    font-size:14px !important;
  }
  @media print {
    color: black !important;
    line-height: 1.5;
    font-size: 16px;
    margin-bottom: 8px;
    orphans: 2;
    widows: 2;
  }
`;

const StyledImage = styled(Image)`
  border-radius: 18px;
  margin: 0 0 10px 0;
  max-width: 100%;
  border: 6px solid black;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);

  @media print {
    max-width: 75%;
    border: 2px solid #000;
    margin-bottom: 10px;
    box-shadow: none;
  }
`;

const PrintContainerHidden = styled.div`
  @media print {
    visibility: hidden !important;
    display: none !important;
  }
`;

const PrintBlock = styled.div`
  @media print {
    padding-top: 10mm;
    padding-bottom: 4mm;
    page-break-inside: avoid;
    break-inside: avoid;
  }
`;

const ImageSkeleton = styled(Skeleton.Image)`
  height: 250px !important;
  width: 100% !important;
  border: 2px solid black;
  border-radius: 18px;
`;
const ViewStoryHandler = ({ storyInfo }) => {
  const showAlert = useAlert();
  const [isVisableToStudent, setIsVisbleToStudent] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const currentUser = useCurrentUser();
  const currentClass  = useCurrentClass();
  const dispatch = useDispatch();
  const {createCollectionSoyNotification, deleteCollectionSoyNotification} = useNotificationHistorias();

  useEffect(() => {

    setIsVisbleToStudent(storyInfo?.activate_for_student);
    setIsLoaded(false);
  }, [storyInfo?.id, storyInfo?.activate_for_student]);

  const handleNotificationShare = async () => {
    try{
      const data = {
        id: v4(),
        title: "Soy Historias",
        class_id: currentClass?.id,
        createdBy: currentUser?.id,
        user_seen: JSON.stringify([]),
        message: `${storyInfo?.story_title} story shared`,
        url: window.location.pathname + window.location.search + window.location.hash,
        story_id: storyInfo?.id,
        data: {
          chapter: storyInfo?.chapter
        }
      }
      await createCollectionSoyNotification(data);
      showAlert("Soy Historias Shared Successfully!", "success");
    }catch(error){
      Sentry.captureException(error);
    }
  }

  const onClick = async () => {
    const nextVisibleState = !isVisableToStudent;
    setIsVisbleToStudent(nextVisibleState);
    setIsLoaded(true);
    try {
      await dispatch(handleShareSoyStoryToStudent(storyInfo?.id, nextVisibleState));
      showAlert(`Soy Historias ${nextVisibleState ? "Visible" : "Hidden"} to student successfully!`, "success");
      setIsLoaded(false);
      if (!isVisableToStudent) {
        await handleNotificationShare();
     } else {
       await deleteCollectionSoyNotification(currentClass?.id, storyInfo?.id);
     }
    } catch (error) {
      Sentry.captureException(`386 Error in handleShareSoyStoryToStudent: ${error}`);
      console.log("Error in handleShareSoyStoryToStudent", error);
      setIsVisbleToStudent(!nextVisibleState);
      setIsLoaded(false);
    } finally {
      setIsLoaded(false);
    }
  };

  return (
      <ToggleWrapper>
        {isLoaded ? (
          <Loading size={18} white={true} />
        ) : (
          <Tooltip title={isVisableToStudent ? "Hide to Student" : "Show to Student"}>
          <VisibilityToggle
            checked={!!isVisableToStudent}
            onChange={() => onClick(!isVisableToStudent)}
            disabled={isLoaded}
          />
          </Tooltip>
        )}
        <ToggleText>
          {isLoaded
            ? "Updating..."
            : isVisableToStudent
              ? "Hide to Student"
              : "Show to Student"}
        </ToggleText>
      </ToggleWrapper>
  );
};

const escapeHtml = (text) => {
  if (!text) return '';
  const placeholders = [];
  let placeholderIndex = 0;
  let processedText = text.replace(/<b>.*?<\/b>/gi, (match) => {
    const placeholder = `__BOLD_PLACEHOLDER_${placeholderIndex}__`;
    placeholders[placeholderIndex] = match;
    placeholderIndex++;
    return placeholder;
  });
  const div = document.createElement('div');
  div.textContent = processedText;
  let escaped = div.innerHTML;
  placeholders.forEach((boldTag, index) => {
    escaped = escaped.replace(`__BOLD_PLACEHOLDER_${index}__`, boldTag);
  });
  return escaped;
};

const unwrapFullBoldParagraph = (para) => {
  if (para == null || typeof para !== 'string') {
    return { inner: para || '', wrap: null };
  }
  const t = para.trim();
  let m = /^<b\s*>([\s\S]*?)<\/b\s*>$/i.exec(t);
  if (m) return { inner: m[1].trim(), wrap: 'b' };
  m = /^<strong\s*>([\s\S]*?)<\/strong\s*>$/i.exec(t);
  if (m) return { inner: m[1].trim(), wrap: 'strong' };
  return { inner: para, wrap: null };
};

const mapWord = (paragraphs, timestampData, images, isStream) => {
  let int_index = 0;
  let global_index = 0;

  const unwrappedParas = paragraphs?.map(unwrapFullBoldParagraph) || [];

  const paragraphWords = unwrappedParas.map(({ inner }) => {
    const s = (inner || '').trim();
    if (!s) return [];
    return s.split(/\s+/).filter((w) => w.length > 0);
  });

  return unwrappedParas?.map(({ wrap }, paraIndex) => {
    const sectionWords = paragraphWords[paraIndex] || [];
    
    if (!sectionWords || sectionWords.length === 0) {
      return null;
    }
    
    const modifiedWords = sectionWords.map((word) => {
      const item = timestampData[global_index];
      const item_index = global_index;
      if (item) {
        const cleanWord = word.replace(/<[^>]*>/g, '').trim();
        if (item.value === cleanWord) {
          global_index++;
        } else if (item.value && item.value.includes(cleanWord)) {
          const arr = item.value.split(" ");
          if (arr.length === 1 || arr[arr.length - 1] === cleanWord) {
            global_index++;
          }
        } else {
          global_index++;
        }
      }
      
      const currentIndex = ++int_index;
      let processedWord = word;
      
      const openBoldCount = (word.match(/<b>/g) || []).length;
      const closeBoldCount = (word.match(/<\/b>/g) || []).length;
      
      if (openBoldCount > closeBoldCount) {
        const missingCloses = openBoldCount - closeBoldCount;
        processedWord = processedWord + '</b>'.repeat(missingCloses);
      } else if (closeBoldCount > openBoldCount) {
        const missingOpens = closeBoldCount - openBoldCount;
        processedWord = '<b>'.repeat(missingOpens) + processedWord;
      }
      
      const escapedWord = escapeHtml(processedWord);
      const sanitizedWordForClass = word.replace(/<[^>]*>/g, '').replace(/["']/g, '-');
      
      return `<span style="cursor:pointer;" data-start="${currentIndex}" data-index="${item_index}" class="story_word ${item_index}-${sanitizedWordForClass}" id="${item_index}_word">${escapedWord}</span>`;
    });

    if ((isStream || images?.length === 0) && paraIndex < 3) {
      modifiedWords.unshift(
        `<span class="image-skeleton-placeholder">
          <label>Generating images...</label>
        </span>`
        );
    } else if (images && images[paraIndex]) {
      modifiedWords.unshift(
        `<img src="${images[paraIndex]}" alt="Story illustration for paragraph ${paraIndex + 1}" class="aiGenerateImg story-inline-img" data-image-src="${images[paraIndex]}" draggable="false" style="display:block;max-width:100%;border-radius:18px;margin:10px auto 10px auto;border:6px solid black;box-shadow:0 4px 10px rgba(0,0,0,0.2);cursor:pointer;-webkit-user-select:none;user-select:none;-webkit-user-drag:none;" />`
      );
    }
    const joined = modifiedWords.join(' ');
    return wrap ? `<${wrap}>${joined}</${wrap}>` : joined;
  }).filter(Boolean);
};

const StoryWithImages = forwardRef(({ text, images, title, storyInfo, is_student, imageConfiguration, enable_student_share = true, isLevel = false,isStream = false, openStoryWithAiView = false, isStory = false, storyEditableText, onStoryEditableTextChange }, ref) => {
  const storyContainerHeight = imageConfiguration?.clientHeight;
  const [timestampData, setTimestampData] = useState([]);
  const [audioVersion, setAudioVersion] = useState('female');
  const [imageModal, setImageModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const isStoryTextControlled = typeof onStoryEditableTextChange === 'function';
  const [internalEditableText, setInternalEditableText] = useState(text || "");
  const editableText = isStoryTextControlled ? (storyEditableText ?? '') : internalEditableText;
  const setEditableText = isStoryTextControlled ? onStoryEditableTextChange : setInternalEditableText;
  const paragraphs = mapWord(editableText?.split('\n').filter(Boolean), timestampData, images, isStream);
  const last_index = useRef(0);
  const audioRef = useRef();
  const contentWrapperRef = useRef(null);
  const location = useLocation();
  const stripHtmlTags = (html) => html?.replace(/<[^>]*>/g, '') || '';
  useEffect(() => {
    if (!isStoryTextControlled) {
      setInternalEditableText(text || "");
    }
  }, [text, storyInfo?.id, isStoryTextControlled]);
  function getTimeStamp(text) {
    try {
      const value = JSON.parse(text);
      if (Array.isArray(value)) {
        return value;
      }
      const lines = text.trim().split('\n').map((line) => JSON.parse(line));
      return lines;
    } catch (error) {
      const lines = text.trim().split('\n').map((line) => JSON.parse(line));
      return lines;
    }
  }
  useEffect(() => {
    const loadTimestamps = async () => {
      const url = audioVersion === 'male' ? storyInfo?.male_audio_timestamp : storyInfo?.female_audio_timestamp;
      if (!url) return setTimestampData([]);

      try {
        const res = await fetch(url);
        const text = await res.text();
        const lines = getTimeStamp(text);
        setTimestampData(lines);
      } catch (err) {
        Sentry.captureException(`387 Error loading timestamp JSON: ${err}`);
        console.error('Error loading timestamp JSON:', err);
        setTimestampData([]);
      }
    };
    loadTimestamps();
  }, [storyInfo, audioVersion]);
  const handleAudioProgress = (time) => {
    let currentIndex = timestampData?.findIndex((entry, idx) => entry.time <= time && (idx === timestampData.length - 1 || timestampData[idx + 1].time > time));
    if (currentIndex === -1 || currentIndex === last_index.current) return;
    const highlightRoot = contentWrapperRef.current;
    const clearSelector = '.story_word.highlighted';
    if (highlightRoot) {
      highlightRoot.querySelectorAll(clearSelector).forEach((el) => {
        el.classList.remove('highlighted');
      });
    } else {
      document.querySelectorAll(clearSelector).forEach((el) => {
        el.classList.remove('highlighted');
      });
    }
    const item = highlightRoot
      ? highlightRoot.querySelector(`[id="${currentIndex}_word"]`)
      : document.getElementById(`${currentIndex}_word`);
    last_index.current = currentIndex;
    if (item) {
      item.classList.add('highlighted');
    }
  };
  useEffect(() => {
    const handleClick = (e) => {
      const imageElement = e.target.closest('.story-inline-img, .aiGenerateImg');
      if (imageElement) {
        const imageSrc = imageElement.getAttribute('data-image-src') || imageElement.getAttribute('src');
        if (imageSrc) {
          setSelectedImage(imageSrc);
          setImageModal(true);
          return;
        }
      }

      const wordElement = e.target.closest('.story_word');
      if (!wordElement) return;

      const index = parseInt(wordElement.getAttribute('data-index'), 10);
      if (timestampData[index] && audioRef.current?.setTime) {
        const time = timestampData[index].time;
        audioRef.current.setTime(time);
      }
    };

    const container = contentWrapperRef.current;
    if (container) container.addEventListener('click', handleClick);
    return () => {
      if (container) container.removeEventListener('click', handleClick);
    };
  }, [timestampData]);

  const SkeltonImage = (index) => (index <= 2 ? <ImageSkeleton active /> : null);

  return (
    <SentryWrap>
      <style
        dangerouslySetInnerHTML={{
          __html: `
          @page {
            margin: 15mm 10mm 28mm 10mm;
            size: auto;
          }
          .aiGenerateImg,
          .story-inline-img {
            -webkit-user-select: none !important;
            user-select: none !important;
            -webkit-user-drag: none !important;
          }
          @media print {
            html, body {
              overflow: visible !important;
              height: auto !important;
            }
            .printable, .printable *:not(img) {
              overflow: visible !important;
              max-height: none !important;
            }
            .soy-historia-print-wrapper {
              overflow: visible !important;
              height: auto !important;
              max-height: none !important;
            }
            .highlighted {
              background-color: transparent !important;
              color: inherit !important;
            }
            .aiGenerateImg,
            .story-inline-img {
              border-radius: 18px !important;
              border: 6px solid #000 !important;
              box-shadow: 0 4px 10px rgba(0,0,0,0.2) !important;
              max-width: 100% !important;
              margin: 10px auto !important;
              display: block !important;
            }
          }
          `,
        }}
      />
      <Container className={`1313 to_be_print printable story-widget-container ${openStoryWithAiView ? 'story-view-modal-ai-generated' : ''}`} ref={ref}>
        {!is_student && !isStream ? (
          <span style={{ position: "absolute", top: 0, right: 5, display: "inline-flex", alignItems: "center", gap: 4, zIndex: 5 }}>
            {!is_student && enable_student_share && !isStream ? <ViewStoryHandler key={storyInfo?.id} storyInfo={storyInfo} /> : null}
          </span>
        ) : null}
        <StyledTitle level={2}>{stripHtmlTags(title) || ''}</StyledTitle>
        <PrintContainerHidden>
          <StoryAudioReader
            id={storyInfo?.id}
            ref={audioRef}
            male_audio={isStream ? '' : storyInfo?.male_audio}
            female_audio={isStream ? '' : storyInfo?.female_audio}
            player={true}
            onTimeUpdate={handleAudioProgress}
            onVoiceChange={(version) => {
              last_index.current = 0;
              setAudioVersion(version);
            }}
            paragraph={paragraphs}
          />
        </PrintContainerHidden>

        <ContentWrapper className='aiGenerateUpr' $isStudent={is_student} $storyContainerHeight={storyContainerHeight} ref={contentWrapperRef} $isLevel={isLevel} $location={location} $isStory={isStory}>
          {paragraphs?.map((para, index) => (
            <PrintBlock key={index} className='aiGenerateTxt'>
              <StyledParagraph>
                <StyledHtml dangerouslySetInnerHTML={{ __html: para }} />
              </StyledParagraph>
            </PrintBlock>
          ))}
        </ContentWrapper>

      </Container>
      <ModalMenu
        type="imageModal"
        image={selectedImage}
        open={imageModal}
        close={() => {
          setImageModal(false);
          setSelectedImage(null);
        }}
      />
    </SentryWrap>
  );
});

export default StoryWithImages;
